import React from "react";
import UserWrapper from "./importUser.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import ImportUserForm from "../../components/importUser/ImportUserForm";

const ImportUser = props => {
  const submitFormHandler = (data, action) => {
    setTimeout(() => {
      props.history.push("/client");
    }, 2000);
  };

  return (
    <UserWrapper {...props}>
      <div className="pos-relative">
        <PageTitle
          props={props}
          title="sidebar.import_user"
          className="plr-15"
          breadCrumb={[
            {
              name: "sidebar.dashboard",
              url: "/dashboard"
            },
            {
              name: "sidebar.import_user"
            }
          ]}
        />
      </div>

      <div className="plr-15">
        <div className="roe-card-style mtb-15">
          <div className="roe-card-header module-header">
            <div className="flex-1 fs-16 demi-bold-text">
              <span className="hash"># </span> Import User
            </div>
          </div>
          <div className="roe-card-body">
            <ImportUserForm
              onSubmit={submitFormHandler}
              action={"add"}
              {...props}
            />
          </div>
        </div>
      </div>
    </UserWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    ...state.permissionReducer
  };
};

export default connect(mapStateToProps, null)(ImportUser);
